<div class="loading-skeleton">
    <div class="grid grid-flow-col gap-4" *ngFor="let cols of items" >
        <div class="" *ngFor="let col of cols">
            <div *ngIf="col" class="animate-pulse content" [style.height]="col + 'rem' "></div>
            <div *ngIf="!col" class="animate-pulse content" >&nbsp col {{col}}</div>
        </div>
    </div>
</div>
